import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";

const PrivateRoute = () => {
  const { user, loading } = useAuth();

  if (loading) return <div><p className="text-muted">Please wait a while, Authenticating ...</p></div>;

  return user ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoute;